import React, {Fragment, useState, useRef} from 'react';
import Popup from './Popup';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {Text, Date_picker, TextEditor, Select as Select_tool} from '../../../../../../../components';
import Grid from '@material-ui/core/Grid';
import { Field, Form } from 'react-final-form';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import NoteIcon from '@material-ui/icons/Note';
import DealSelect from './DealSelect';
import {connect} from 'react-redux';

function Notes(props){
  let formRef=useRef();
  let fp=useRef();

  const[delete_mode, setDeleteMode]=useState(false);
  function onSubmit(params){
    formRef.current.reportValidity();
    if(formRef.current.checkValidity()==true){
      if(params.contact_id==null){delete params.contact_id;}
      if(params.sub_type=='' || params.sub_type==false || params.sub_type==0 || params.sub_type==undefined){params.sub_type=0;}
      if(params.id!=undefined){if(props.initial_note.contact_id!=undefined){params.original_type='contact';}else{params.original_type='company';} params.company_id=props.company.id; props.updateTimelineItem(params.id, 'notes', params);}
      else{props.createTimelineItem('notes', {...params, company_id:props.company.id});}
      if(params.completed_task_id!=undefined && params.no_follow_up!=true){props.setNewTaskPrompt(true);}
      props.handleClose();
    }
  }


  let contact_list=[{id:null, name:'No contact'}];
  if(props.company!=undefined){for(let x of props.company.contacts){
    if(x.pivot.active_at_company==true){
      let contact={id:x.id};
      if(x.first_name!=null){contact.name=x.first_name+' ';}
      if(x.last_name!=null){contact.name+=x.last_name;}
      if(contact.name==undefined){contact.name='No name';}
      contact_list.push(contact);
  }}}
  let inn={}; let pin=props.initial_note; if(pin!=undefined){inn=pin;}
  let note_title=(inn.sub_type==2)?'Research Note':'Note';
  inn.deal_id=(inn.deal_id!=undefined)?inn.deal_id:(props.main_deals==undefined || props.main_deals[props.company.id]==undefined)?undefined:props.main_deals[props.company.id];
  return(
    <Popup initial_values={props.initial_note} openDraft={props.reOpen} draft_type="NOTE" company_id={props.company.id} form_props={fp}  button_text={(delete_mode==true)?'Delete':'Save'} title={(delete_mode==true)?"Delete "+note_title:(props.timeline_item!=undefined || (inn!=undefined && inn.id!=undefined))?'Update '+note_title:'Create '+note_title} submit_button icon={<NoteIcon color='primary'/>} handleClose={()=>{if(inn!=undefined && inn.completed_task_id!=undefined && inn.ignore_complete_anyway!=true){props.handleClose(inn.completed_task_id);}else{props.handleClose();}}} handleDelete={((props.initial_note==undefined || props.initial_note.id==undefined || delete_mode==true) ||  props.initial_note.sub_type==2)?undefined:()=>{setDeleteMode(true);}} accept_button_click={()=>{if(delete_mode==true){props.deleteTimelineItem(props.initial_note.id, 'notes', props.company.id); props.handleClose()}else{fp.current.form.submit()}}} content={
          <Form
          onSubmit={onSubmit}
          initialValues={inn}
          >
            {form_props =>{ fp.current=form_props; return(
              <form ref={formRef} onSubmit={form_props.handleSubmit}>
                {(delete_mode==true)?
                  <Typography style={{width:'calc(100% - 40px)', height:'100px', marginTop:'50px', textAlign:'center'}}>Are you sure you want to delete this note? This action can not be undone.</Typography>
                  :
                <Grid container style={{width:'calc(100% - 40px)'}}>
                  <Grid item xs={12} style={{marginBottom:'10px', marginTop:'-5px'}}><Field name='sub_type'>{(f)=>(f.input.value==2)?null:<FormControlLabel control={<Checkbox style={{marginLeft:'10px'}} checked={(f.input.value==2)?true:f.input.value} onChange={f.input.onChange} name="sub_type" color="primary"/>} label="Pin note"/>}</Field></Grid>
                  <Grid item xs={12} sm={6} style={{marginBottom:'10px'}}><Field name='date_time'>{(f)=><Date_picker date_time title='Date' value={f.input.value} onChange={f.input.onChange}/>}</Field></Grid>
                  <Grid item xs={12} sm={6} style={{marginBottom:'10px'}}><Select_tool title='Contact' name='contact_id' variant='outlined' size='small' select_data={contact_list}/></Grid>
                  <DealSelect {...props}/>
                  <Grid item xs={12}><div style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'5px'}}><Field name='timeline_item_content.content'>{(f)=><TextEditor required value={f.input.value} onChange={(e)=>{f.input.onChange(e)}}/>}</Field></div></Grid>
                </Grid>}
            </form>
            )}}
        </Form>
        }/>
  )
}

export default connect(ss, dd)(Notes);

function ss(state){
  return{
    deals:state.deals.deals,
    main_deals:state.deals.main_deals
  }
}


function dd(dispatch){
  return{
  }
}
